import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import axios from 'axios';
import units from './modules/units';
import tasks from './modules/tasks';
import shipments from './modules/shipments';
import transactions from './modules/transactions';
import harvests from './modules/harvests';
import workers from './modules/workers';
import suppliers from './modules/suppliers';
import factories from './modules/factories';
// Create an Axios instance with the API gateway as the base URL
const axiosInstance = axios.create({
    //  baseURL: 'https://api.pacmis.com/api', // Gateway for all requests
      baseURL: 'https://fireflex.pacmis.com/api',
//   baseURL: 'http://apitesting.pacmis/api', // Gateway for all requests
});


// Vuex Store
const store = createStore({
    modules: {
    units,
    tasks,
    shipments,
    harvests,
    workers,
    factories,
    suppliers,
    transactions,
  },
  state: {
    token: null,
    user: null,
    apartments: [],
    tenantRooms: [],
    tenantServices: [],
    apartmentInvoices: [],
    ipAddress: null, // Add state to store IP address
    licenses: [],       // Add licenses state
    subscriptions: [],  // Add subscriptions state
  },
  mutations: {
    setToken(state, token) {
      state.token = token;
    },
    setUser(state, user) {
      state.user = user;
    },
    setApartments(state, apartments) {
      state.apartments = apartments;
    },
    setTenantRooms(state, rooms) {
      state.tenantRooms = rooms;
    },
    setTenantServices(state, services) {
      state.tenantServices = services;
    },
    setApartmentInvoices(state, invoices) {
      state.apartmentInvoices = invoices;
    },
    setIpAddress(state, ip) { // Mutation to set IP address
      state.ipAddress = ip;
    },
    setLicenses(state, licenses) { // Mutation for licenses
        state.licenses = licenses;
      },
      setSubscriptions(state, subscriptions) { // Mutation for subscriptions
        state.subscriptions = subscriptions;
      },
    clearAuthData(state) {
        state.token = null;
        state.user = null;
        state.apartments = [];
        state.tenantRooms = [];
        state.tenantServices = [];
        state.apartmentInvoices = [];
        state.licenses = [];
        state.subscriptions = [];
        state.ipAddress = null;
    },
  },
  actions: {
    async login({ commit }, { phone, password, ip }) {
        try {
          // Define the correct token for the web platform
          const platformToken = 'WebSecureToken123'; // Token for the web platform

          // Make the API call to login
          const response = await axiosInstance.post('/auth/login', {
            phone,
            password,
            platform: 'web', // Include platform identifier for web
            ip, // Send the IP address with the login request
            token: platformToken, // Send the platform-specific token for additional security
          });

          // Destructure token and user from the response
          const { token: responseToken, user } = response.data;

          // Check if the response contains the required fields
          if (responseToken && user) {
            commit('setToken', responseToken); // Set the token in Vuex store
            commit('setUser', user); // Set the user in Vuex store
            commit('setIpAddress', ip); // Set the IP address in Vuex store

            // Set token in headers for future requests
            axios.defaults.headers.common['Authorization'] = `Bearer ${responseToken}`;

            // Save token and user to localStorage for persistence across page reloads
            localStorage.setItem('token', responseToken);
            localStorage.setItem('user', JSON.stringify(user));
          } else {
            // Log and handle an unexpected response
            console.error('Unexpected response structure:', response.data);
            throw new Error('Login failed due to unexpected response structure.');
          }
        } catch (error) {
          // Handle errors such as network issues or invalid credentials
          console.error('Login failed:', error.response || error.message);
          throw error; // Re-throw the error to be caught by the component
        }
      }


,

    async loginWithGoogle({ commit }) {
      try {
        // Start Google OAuth process
        const response = await axiosInstance.get('/auth/google/redirect');

        // Redirect the user to Google's OAuth consent screen
        window.location.href = response.data.url;
      } catch (error) {
        console.error('Google login initiation failed:', error);
        throw error;
      }
    },
    async handleGoogleCallback({ commit }, code) {
      try {
        // Exchange authorization code for token
        const response = await axiosInstance.post('/auth/google/callback', { code });
        const { token, user } = response.data;

        commit('setToken', token);
        commit('setUser', user);

        // Set token in headers for future requests
        axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify(user));
      } catch (error) {
        console.error('Google login callback failed:', error);
        throw error;
      }
    },
    logout({ commit }) {
      commit('clearAuthData');
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      delete axiosInstance.defaults.headers.common['Authorization'];
    },
    async fetchUserRelationships({ commit }) {
      try {
        const response = await axiosInstance.get(`/auth/user/${this.state.user.id}/relationships`);
        const { apartments, rooms, invoices, services } = response.data;

        commit('setApartments', apartments || []);
        commit('setTenantRooms', rooms || []);
        commit('setTenantServices', services || []);
        commit('setApartmentInvoices', invoices || []);
        commit('setLicenses', licenses || []);
        commit('setSubscriptions', subscriptions || []);
      } catch (error) {
        console.error('Error fetching user relationships:', error);
      }
    },
  },
  plugins: [createPersistedState()],
});

export default store;
export { axiosInstance };
